module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/extend.js
// module id = 832
// module chunks = 0